module.exports = __webpack_public_path__ + "static/media/trim-lmm-t.2c13221f.png";